module.exports = __webpack_public_path__ + "img/cover-promotion-bg.b3b782c8.png";